import type { Env } from "@/env-schema";

import { useServices } from "@/services";

export function useEnv(): Env {
  return useServices().env;
}
